import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import "../css/UserLogin.css"; // reuse the same auth/card CSS so visuals match

const ForgetPassword = () => {
  const navigate = useNavigate();

  const [forgetRequest, setForgetRequest] = useState({
    emailId: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleUserInput = (e) => {
    const { name, value } = e.target;
    setForgetRequest((prev) => ({ ...prev, [name]: value }));
  };

  const changePassword = (e) => {
    e.preventDefault();

    if (forgetRequest.confirmPassword !== forgetRequest.newPassword) {
      toast.error("Password Not Matching", {
        position: "top-center",
        autoClose: 1000,
      });
      return;
    }

    fetch("https://goldenhides.in/api/user/forget-password", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(forgetRequest),
    })
      .then((result) => result.json())
      .then((res) => {
        if (res.success) {
          toast.success(res.responseMessage, {
            position: "top-center",
            autoClose: 1000,
          });
          setTimeout(() => {
            // navigate to verify page with returned user (if backend provides)
            navigate("/user/verify/forget", {
              state: res.users ? res.users[0] : {},
            });
          }, 1200);
        } else {
          toast.error(res.responseMessage || "Request failed", {
            position: "top-center",
            autoClose: 1200,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("It seems server is down", {
          position: "top-center",
          autoClose: 1200,
        });
      });
  };

  return (
    <div className="auth-background">
      <div className="d-flex align-items-center justify-content-center w-100">
        <div className="card form-card text-color custom-bg user-login-card">
          <div className="card-header bg-color custom-bg-text text-center">
            <h4 className="card-title">Forget Password</h4>
          </div>

          <div className="card-body">
            <form onSubmit={changePassword} noValidate>
              <div className="mb-3 text-color">
                <label htmlFor="emailId" className="form-label">
                  <b>Email Id</b>
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="emailId"
                  name="emailId"
                  onChange={handleUserInput}
                  value={forgetRequest.emailId}
                  required
                />
              </div>

              <div className="mb-3 text-color">
                <label htmlFor="newPassword" className="form-label">
                  <b>New Password</b>
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="newPassword"
                  name="newPassword"
                  onChange={handleUserInput}
                  value={forgetRequest.newPassword}
                  required
                />
              </div>

              <div className="mb-3 text-color">
                <label htmlFor="confirmPassword" className="form-label">
                  <b>Confirm Password</b>
                </label>
                <input
                  type="password"
                  className="form-control"
                  id="confirmPassword"
                  name="confirmPassword"
                  onChange={handleUserInput}
                  value={forgetRequest.confirmPassword}
                  required
                />
              </div>

              <div className="d-flex justify-content-start">
                <button type="submit" className="btn bg-color custom-bg-text">
                  Change Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default ForgetPassword;
